import styled, { css } from 'styled-components'

export const PopUp = styled.div`
  width: 448px;
  height: 263px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.normal};
  `}
`
